module.exports = __webpack_public_path__ + "static/media/tele2.8e8b1771.svg";